

export default function getProducts(room, austattung_produkt){

    const productList = [];
    const chargerProductList = [];
    const charger = [];
    if(
        room.selectedEquipment["usb_steckdosen"] !== undefined
        && room.selectedEquipment["usb_steckdosen"] > 0
        && austattung_produkt["usb-steckdosen"] !== undefined
    ){
        productList.push({
            product: austattung_produkt["usb-steckdosen"],
            count: room.selectedEquipment["usb_steckdosen"]
        })
    }
    if(
        room.selectedEquipment["usb_c_steckdosen"] !== undefined
        && room.selectedEquipment["usb_c_steckdosen"] > 0
        && austattung_produkt["usb-c"] !== undefined
    ){
        const p = { product: austattung_produkt["usb-c"], count: room.selectedEquipment["usb_c_steckdosen"] };
        chargerProductList.push(p);
        for (let i = 0; i < room.selectedEquipment["usb_c_steckdosen"]; i++) { charger.push(p.product); }
    }
    if(
        room.selectedEquipment["magnetic_charger"] !== undefined
        && room.selectedEquipment["magnetic_charger"] > 0
        && austattung_produkt["magnetic-charger"] !== undefined
        && austattung_produkt["mc-abdeckung"] !== undefined
    ){
        const p = { product: austattung_produkt["magnetic-charger"], count: room.selectedEquipment["magnetic_charger"] };
        chargerProductList.push(p);
        const p2 = { product: austattung_produkt["mc-abdeckung"], count: room.selectedEquipment["magnetic_charger"] };
        chargerProductList.push(p2);
        for (let i = 0; i < room.selectedEquipment["magnetic_charger"]; i++) { charger.push(p.product); }
    }
    if(
        room.selectedEquipment["pd_charger"] !== undefined
        && room.selectedEquipment["pd_charger"] > 0
        && austattung_produkt["usb-pd"] !== undefined
        && austattung_produkt["usp-pd-abdeckung"] !== undefined
    ){
        const p = { product: austattung_produkt["usb-pd"], count: room.selectedEquipment["pd_charger"] };
        chargerProductList.push(p);
        const p2 = { product: austattung_produkt["usp-pd-abdeckung"], count: room.selectedEquipment["pd_charger"] };
        chargerProductList.push(p2);
        for (let i = 0; i < room.selectedEquipment["pd_charger"]; i++) { charger.push(p.product+'|'+p2.product); }
    }
    return {productList, aust_list: ["usb_steckdosen"], charger, chargerProductList};
}
